module.exports = __webpack_public_path__ + "img/erlend-simensen-l.38fd9bcd.webp";